import React from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import WidgetInfoSettings from '../../settings_sidebar/WidgetInfoSettings.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

function SDGTotalContributionWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const demo_mode = useSelector(state => state.dashboard.widgets[widgetId].settings?.demo_mode);

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <WidgetTitleSettings widgetId={widgetId} />
            <WidgetInfoSettings widgetId={widgetId} />
            <fieldset>
                <label>
                    <input type="checkbox" name="demo_mode" value="1"
                        style={{ marginRight: "0.5rem"}}
                        checked={demo_mode}
                        onChange={e => setAttribute('settings.demo_mode', e.target.checked)}>
                    </input>
                    {I18n.t('enable_demo_mode')}
                </label>
            </fieldset>
        </CollapsibleSection>
    </>)
}

export default SDGTotalContributionWidgetSettings;
